export default __webpack_public_path__ + "static/media/main.2c7e694d.jpg";